let config = {
  'title': '腾讯翻译君 - 同声传译',
  'keywords': '翻译,在线翻译,腾讯翻译君,翻译在线,英文翻译,英语翻译,日语翻译,韩语翻译,fanyi',
  'description': '翻译君是腾讯最新出品的实时会话翻译软件，支持中、英、日、韩等多门语言。具有精准语言识别，高效、免费等特点。非常适用于境外旅游、对外交流、口语练习等情境，让你体验同声传译般的流畅和快感。'
};

config.layout = require('@layout/single');

require('./index.css');

config.qbtop = [
  require('@modules/header')
];

config.qbheader = [];

config.qbbody = [
  require('@modules/lottery'),
  require('@modules/whyuse'),
  require('@modules/solution'),
  require('@modules/contact')
];

config.qbfooter = [
  require('@modules/footer')
];

module.exports = config;



// WEBPACK FOOTER //
// ./pages/index/config.js